
export const serial = async (commands) => {
  const results = []
  for(let i=0; i<commands.length; ++i) {
    const output = await commands[i]()
    results.push(output)
  }
  return results
}
